import {HttpClient, HttpHeaders}    from "@angular/common/http";
import {Injectable}                 from '@angular/core';

import {AngularQuery}               from "../query/angularquery";
import {College}                    from "./college";

import {map}                        from "rxjs/operators";
import {Observable}                 from "rxjs/Rx";



@Injectable()
export class CollegeService {

	/**
	 * Initialize the object.
	 *
	 * @param {HttpClient} http  Connection to HTTP.
	 */
	constructor(protected http: HttpClient) {}


	/**
	 * Delete the college associated with the specified ID number.
	 *
	 * @param {number} id  The ID of the College to delete.
	 * @returns {Observable<Boolean>} Whether the delete was successful or not.
	 */
	deleteCollege(id:number): Observable<Boolean> {

		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_COLLEGE, id.toString());
		query.useParams(false);
		query.useCacheBuster(false);
		let url:string = query.getUrl();

		return this.http
			.delete<Boolean>(url)
			.pipe(
				map(() => true)
			);

	}


	/**
	 * Get the College object specified by the provided Angular ReST API ID.
	 *
	 * @param id       An Angular ReST API ID value from the "college" table.
	 * @returns {Observable<College>}  An Observable<College> object or error.
	 */
	getCollege(id: number): Observable<College> {

		let query:AngularQuery = new AngularQuery();
		query.setPerPage(1);
		query.setEndpoint(AngularQuery.ENDPOINT_COLLEGE, id.toString());
		let url = query.getUrl();
		return this.http
			.get<College>(url);

	}


	/**
	 * Save the provided college information.
	 *
	 * @param {string} url    The URL to post to.
	 * @param {string} json   The data as a JSON string.
	 * @return {Observable<College>}  The saved College data echoed back.
	 */
	save(url: string, json: string): Observable<College> {

		// Warn them that JSON is coming.
		let headers = new HttpHeaders().append('Content-Type', 'application/json');
		return this.http
			.post<College>(url, json, { headers: headers });

	}


	/**
	 * Search for the college and return an Observable.
	 *
	 * @param {string} name  The name of the college being searched for.
	 * @returns {Observable<College[]>}  An Observable with Colleges found.
	 */
	search(name: string): Observable<College[]> {

		if (2 > name.length) {
			return Observable.of([]);
		}

		let query: AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_COLLEGE);       // Select the table to search.
		query.setPerPage(10);                                   // Limit results to 10 entries.
		query.addParameter('field', 'name');                    // Do a search of the 'name' field.
		query.addParameter('search', '%' + name + '%');
		query.addParameter('order_field', 'name');
		query.addParameter('sort_order', 'ASC');
		let url = query.getUrl();
		return this.http
			.get<College[]>(url);

	}

}



// WEBPACK FOOTER //
// ./src/app/services/college/college.service.ts